import axios from "axios";
import apiClient from "../utils/ApiClient";

export const getRole = async () => {
    try {
        const response = await apiClient.get(`/api/role-list`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const AddRole = async (data) => {
    try {
        const response = await apiClient.post(`/api/add-role`, data);
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const AddUser = async (data) => {    
    try {
        const response = await apiClient.post(
            `/api/add-user`, 
            data);
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};


export const getUsers = async (currentPage,itemsPerPage) => {
    try {
        const response = await apiClient.get(`/api/all-users?page=${currentPage}&listData=${itemsPerPage}`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const editUsers = async (id) => {
    try {
        const response = await apiClient.get(`/api/edit-user?user_id=${id}`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const deleteUser = async (id) => {
    try {
        const response = await apiClient.get(`/api/destroy-user?user_id=${id}`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

export const dashboardData = async () => {
    try {
        const response = await apiClient.get(`/api/dashboard-data`)
        return response.data;  // Return the response data
    } catch (error) {
        return error?.response?.data;  // Return error data if request fails
    }
};

